import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "soBenhAn" }, "Số bệnh án", -1)
const _hoisted_4 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "baoCaoSC" }, "Hình thức báo cáo sự cố y khoa", -1)
const _hoisted_6 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "soBC" }, "Số báo cáo/Mã số sự cố", -1)
const _hoisted_8 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "ngayBC" }, "Ngày báo cáo", -1)
const _hoisted_10 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "donViBC" }, "Đơn vị báo cáo", -1)
const _hoisted_12 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "doiTuongSC" }, "Đối tượng xảy ra xự cố", -1)
const _hoisted_14 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "noiXayRaSC" }, "Nơi xảy ra sự cố", -1)
const _hoisted_16 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "viTri" }, "Vị trí cụ thể", -1)
const _hoisted_18 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "thoiGianSC" }, "Ngày/Thời gian xảy ra sự cố", -1)
const _hoisted_20 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { for: "moTaSC" }, "Mô tả ngắn gọn về sự cố", -1)
const _hoisted_22 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "giaiPhapBanDau" }, "Đề xuất giải pháp ban đầu", -1)
const _hoisted_24 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { for: "dieuTriBanDau" }, "Điều trị/Xử lý ban đầu đã được thực hiện", -1)
const _hoisted_26 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { for: "thongBaoChoBS" }, "Thông báo cho BS điều trị/Người có trách nhiệm", -1)
const _hoisted_28 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { for: "ghiNhanHS" }, "Ghi nhận vào hồ sơ bệnh án/giấy tờ liên quan", -1)
const _hoisted_30 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { for: "thongBaoChoNN" }, "Thông báo cho người nhà/Người bảo hộ", -1)
const _hoisted_32 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { for: "thongBaoChoNB" }, "Thông báo cho người bệnh", -1)
const _hoisted_34 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { for: "phanLoaiBD" }, "Phân loại ban đầu về sự cố", -1)
const _hoisted_36 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { for: "danhGiaBD" }, "Đánh giá ban đầu về mức độ ảnh hưởng của sự cố", -1)
const _hoisted_38 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { for: "hoTenNguoiBC" }, "Họ tên người báo cáo", -1)
const _hoisted_40 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { for: "soDT" }, "Số điện thoại người báo cáo", -1)
const _hoisted_42 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { for: "year" }, "Thông tin người báo cáo", -1)
const _hoisted_44 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { for: "nguoiCK1" }, "Người chứng kiến 1", -1)
const _hoisted_46 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { for: "nguoiCK2" }, "Người chứng kiến 2", -1)
const _hoisted_48 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { for: "nguoiBC" }, "Người lập báo cáo", -1)
const _hoisted_50 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_51 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_52 = { id: "loading" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", null, "Đang lưu thông tin, vui lòng chờ ...", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmPopup),
    _createVNode(_component_Panel, {
      style: {"text-align":"center","height":"50%"},
      header: "Báo cáo sự cố y khoa"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_InputText, {
              id: "soBenhAn",
              type: "text",
              modelValue: $setup.medicalIncident.so_benh_an,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.medicalIncident.so_benh_an) = $event)),
              placeholder: "Vui lòng nhập số bệnh án ",
              style: {"text-align":"center"}
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_Dropdown, {
              id: "baoCaoSC",
              filter: true,
              showClear: true,
              modelValue: $setup.medicalIncident.hinh_thuc_bc,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.medicalIncident.hinh_thuc_bc) = $event)),
              options: $setup.baoCaoSC,
              optionLabel: "Name",
              optionValue: "Name",
              placeholder: "Vui lòng chọn hình thức",
              style: {"text-align":"center"}
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_InputText, {
              id: "soBC",
              type: "text",
              modelValue: $setup.medicalIncident.so_bc,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.medicalIncident.so_bc) = $event)),
              placeholder: "Vui lòng nhập năm sinh",
              style: {"text-align":"center"}
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_Calendar, {
              id: "ngayBC",
              modelValue: $setup.medicalIncident.ngay_bc,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.medicalIncident.ngay_bc) = $event)),
              selectionMode: "single",
              dateFormat: "dd/mm/yy",
              showButtonBar: true,
              showIcon: true,
              manualInput: false,
              monthNavigator: true,
              yearNavigator: true,
              yearRange: "2000:2100"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_Dropdown, {
              id: "donViBC",
              filter: true,
              showClear: true,
              modelValue: $setup.medicalIncident.don_vi_bc,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.medicalIncident.don_vi_bc) = $event)),
              options: $setup.donViBC,
              optionLabel: "name",
              optionValue: "name",
              placeholder: "Vui lòng chọn đơn vị",
              style: {"text-align":"center"}
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_Dropdown, {
              id: "doiTuongSC",
              filter: true,
              showClear: true,
              modelValue: $setup.medicalIncident.doi_tuong_xay_ra_sc,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.medicalIncident.doi_tuong_xay_ra_sc) = $event)),
              options: $setup.doiTuongXayRaSC,
              optionLabel: "Name",
              optionValue: "Name",
              placeholder: "Vui lòng chọn đối tượng",
              style: {"text-align":"center"}
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_Dropdown, {
              id: "noiXayRaSC",
              filter: true,
              showClear: true,
              modelValue: $setup.medicalIncident.noi_xay_ra_sc,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.medicalIncident.noi_xay_ra_sc) = $event)),
              options: $setup.noiXayRaSC,
              optionLabel: "name",
              optionValue: "name",
              placeholder: "Vui lòng chọn nơi xãy ra sự cố",
              style: {"text-align":"center"}
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(_component_InputText, {
              id: "viTri",
              type: "text",
              modelValue: $setup.medicalIncident.vi_tri_cu_the,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.medicalIncident.vi_tri_cu_the) = $event)),
              placeholder: "Vui lòng nhập vị trí",
              style: {"text-align":"center"}
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createVNode(_component_Calendar, {
              id: "thoiGianSC",
              modelValue: $setup.medicalIncident.thoi_gian_xay_ra_sc,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.medicalIncident.thoi_gian_xay_ra_sc) = $event)),
              selectionMode: "single",
              dateFormat: "dd/mm/yy",
              showButtonBar: true,
              showIcon: true,
              showSeconds: true,
              showTime: true,
              manualInput: false,
              monthNavigator: true,
              yearNavigator: true,
              yearRange: "2000:2100"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createVNode(_component_InputText, {
              id: "moTaSC",
              type: "text",
              modelValue: $setup.medicalIncident.mo_ta_sc,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.medicalIncident.mo_ta_sc) = $event)),
              placeholder: "Vui lòng mô tả về sự cố",
              style: {"text-align":"center"}
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createVNode(_component_InputText, {
              id: "giaiPhapBanDau",
              type: "text",
              modelValue: $setup.medicalIncident.de_xuat_giai_phap,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.medicalIncident.de_xuat_giai_phap) = $event)),
              placeholder: "Vui lòng nhập đề xuất",
              style: {"text-align":"center"}
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createVNode(_component_InputText, {
              id: "dieuTriBanDau",
              type: "text",
              modelValue: $setup.medicalIncident.dieu_tri,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.medicalIncident.dieu_tri) = $event)),
              placeholder: "Vui lòng nhập xử lý ban đầu",
              style: {"text-align":"center"}
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createVNode(_component_Dropdown, {
              id: "thongBaoChoBS",
              filter: true,
              showClear: true,
              modelValue: $setup.medicalIncident.thong_bao_cho_bs,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.medicalIncident.thong_bao_cho_bs) = $event)),
              options: $setup.danhSachTuyChon,
              optionLabel: "Name",
              optionValue: "Name",
              placeholder: "Vui lòng chọn thông báo",
              style: {"text-align":"center"}
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createVNode(_component_Dropdown, {
              id: "ghiNhanHS",
              filter: true,
              showClear: true,
              modelValue: $setup.medicalIncident.ghi_nhan_vao_hs,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.medicalIncident.ghi_nhan_vao_hs) = $event)),
              options: $setup.danhSachTuyChon,
              optionLabel: "Name",
              optionValue: "Name",
              placeholder: "Vui lòng chọn ghi nhận",
              style: {"text-align":"center"}
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createVNode(_component_Dropdown, {
              id: "thongBaoChoNN",
              filter: true,
              showClear: true,
              modelValue: $setup.medicalIncident.thong_bao_cho_nguoi_nha,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.medicalIncident.thong_bao_cho_nguoi_nha) = $event)),
              options: $setup.danhSachTuyChon,
              optionLabel: "Name",
              optionValue: "Name",
              placeholder: "Vui lòng chọn thông báo",
              style: {"text-align":"center"}
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _createVNode(_component_Dropdown, {
              id: "thongBaoChoNB",
              filter: true,
              showClear: true,
              modelValue: $setup.medicalIncident.thong_bao_cho_nguoi_benh,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.medicalIncident.thong_bao_cho_nguoi_benh) = $event)),
              options: $setup.danhSachTuyChon,
              optionLabel: "Name",
              optionValue: "Name",
              placeholder: "Vui lòng chọn thông báo",
              style: {"text-align":"center"}
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createVNode(_component_Dropdown, {
              id: "phanLoaiBD",
              filter: true,
              showClear: true,
              modelValue: $setup.medicalIncident.phan_loai_ban_dau_ve_sc,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.medicalIncident.phan_loai_ban_dau_ve_sc) = $event)),
              options: $setup.danhSachTuyChon,
              optionLabel: "Name",
              optionValue: "Name",
              placeholder: "Vui lòng chọn phân loại",
              style: {"text-align":"center"}
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _hoisted_37,
            _createVNode(_component_Dropdown, {
              id: "danhGiaBD",
              filter: true,
              showClear: true,
              modelValue: $setup.medicalIncident.danh_gia_ban_dau,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.medicalIncident.danh_gia_ban_dau) = $event)),
              options: $setup.danhSachTuyChon,
              optionLabel: "Name",
              optionValue: "Name",
              placeholder: "Vui lòng chọn đánh giá",
              style: {"text-align":"center"}
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createVNode(_component_InputText, {
              id: "hoTenNguoiBC",
              type: "text",
              modelValue: $setup.medicalIncident.ho_ten_nguoi_bc,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.medicalIncident.ho_ten_nguoi_bc) = $event)),
              placeholder: "Vui lòng nhập tên người báo cáo",
              style: {"text-align":"center"}
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _createVNode(_component_InputText, {
              id: "soDT",
              type: "text",
              modelValue: $setup.medicalIncident.so_dien_thoai_bc,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.medicalIncident.so_dien_thoai_bc) = $event)),
              placeholder: "Vui lòng nhập số điện thoại",
              style: {"text-align":"center"}
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _hoisted_43,
            _createVNode(_component_Dropdown, {
              id: "province",
              filter: true,
              showClear: true,
              modelValue: $setup.medicalIncident.thong_tin_nguoi_bc,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.medicalIncident.thong_tin_nguoi_bc) = $event)),
              options: $setup.thongTinNguoiBC,
              optionLabel: "Name",
              optionValue: "Name",
              placeholder: "Vui lòng chọn thông tin",
              style: {"text-align":"center"}
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _hoisted_45,
            _createVNode(_component_InputText, {
              id: "nguoiCK1",
              type: "text",
              modelValue: $setup.medicalIncident.nguoi_chung_kien1,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.medicalIncident.nguoi_chung_kien1) = $event)),
              placeholder: "Vui lòng nhập người chứng kiến 1",
              style: {"text-align":"center"}
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _hoisted_47,
            _createVNode(_component_InputText, {
              id: "nguoiCK2",
              type: "text",
              modelValue: $setup.medicalIncident.nguoi_chung_kien2,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.medicalIncident.nguoi_chung_kien2) = $event)),
              placeholder: "Vui lòng nhập người chứng kiến 2",
              style: {"text-align":"center"}
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _hoisted_49,
            _createVNode(_component_InputText, {
              id: "nguoiBC",
              type: "text",
              modelValue: $setup.medicalIncident.nguoi_lap_bc,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (($setup.medicalIncident.nguoi_lap_bc) = $event)),
              style: {"text-align":"center"}
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createVNode(_component_Button, {
              label: "Báo Cáo",
              icon: "pi pi-plus-circle",
              iconPos: "left",
              onClick: _cache[24] || (_cache[24] = ($event: any) => ($setup.addMedicalIncident())),
              style: {"align-items":"center","width":"15vw"},
              disabled: !$setup.valid()
            }, null, 8, ["disabled"])
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_51, [
      _createVNode(_component_Dialog, {
        header: "Đang xử ",
        visible: $setup.loadingBar,
        "onUpdate:visible": _cache[25] || (_cache[25] = ($event: any) => (($setup.loadingBar) = $event)),
        closable: false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_52, [
            _hoisted_53,
            _createVNode(_component_ProgressBar, {
              mode: "indeterminate",
              style: {"height":".3em"}
            })
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ], 64))
}